<ng-container *ngIf="displayLayout; then showLogo; else notShowLogo"></ng-container>
<ng-template #showLogo>
	<section class="uk-section uk-position-relative" uk-height-viewport>
		<div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
			<div class="uk-text-center uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
				<ng-container *ngIf="themeCode() === 'nissan'; else dynamicHeader">
					<div class="uk-padding" style="background-color:#be1e2d;">
						<img src="/assets/images/logo-nissan-insure.png" [alt]="title['nissan']" width="220"
							*ngIf="themeCode() === 'nissan'">
					</div>
				</ng-container>
				<ng-template #dynamicHeader>
					<div class="uk-padding header">
						<img src="/assets/images/logo-insure.png" [alt]="title['insure']" width="220"
							*ngIf="themeCode() === 'insure'">
						<img src="/assets/images/logo-ford-insure.png" [alt]="title['ford']" width="220"
							*ngIf="themeCode() === 'ford'">
						<img src="/assets/images/logo-mazda-insure.png" [alt]="title['mazda']" width="220"
							*ngIf="themeCode() === 'mazda'">
						<img src="/assets/images/logo-mitsu-insure.png" [alt]="title['mitsu']" width="220"
							*ngIf="themeCode() === 'mitsu'">
						<img src="/assets/images/logo-lpp-insure.png" [alt]="title['lpp']" width="220"
						     *ngIf="themeCode() === 'lpp'">
						<img src="/assets/images/logo-gwm2.png" [alt]="title['gwm']" width="220"
						     *ngIf="themeCode() === 'gwm'">
					</div>
				</ng-template>
				<ng-container *ngIf="buyInsuranceOnlineClosedFlag(); else maintainance">
					<br>
					<h2 class="uk-text-center" style="padding-left:10px;padding-right:10px;"
						[innerHTML]="buyInsuranceOnlineClosedDesc()"></h2>
				</ng-container>
				<ng-template #maintainance>
					<div class="uk-container uk-container-small">
						<div class="uk-card uk uk-card-body" *ngIf="!next()">
							<div class="loader">Loading...</div>
						</div>
						<div class="uk-card uk uk-card-body" *ngIf="next()">
							<router-outlet></router-outlet>
						</div>
					</div>
				</ng-template>

			</div>
		</div>

		<div class="uk-position-bottom-center uk-padding-small">
			<small class="uk-text-middle">© สงวนลิขสิทธิ์ 2562 บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด</small>
		</div>
		<app-loader *ngIf="(loader | async)"></app-loader>
	</section>
</ng-template>
<ng-template #notShowLogo>
	<section style="padding-top: 0%;" class="uk-section uk-position-relative" uk-height-viewport>
		<router-outlet></router-outlet>
		<div class="uk-position-bottom-center uk-padding-small">
			<small class="uk-text-middle">© สงวนลิขสิทธิ์ 2562 บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด</small>
		</div>
		<app-loader *ngIf="(loader | async)"></app-loader>
	</section>
</ng-template>
<div class="uk-position-relative">
	<div class="uk-position-bottom-center">
		<small class="uk-text-middle">ReferenceID:{{referenceUUID()}}</small>
	</div>
</div>